import { wrapCall, callGet, callPut } from './helpers'

//* ~~~~~~ CONFIG ROUTES ~~~~~~

// Gets config info for the environment
export const getConfig = async () => {
  return await wrapCall({
    method: callGet,
    uri: `/config`
  })
}
// Gets config namespaces info for the environment
export const getConfigNamespace = async namespaceId => {
  return await wrapCall({
    method: callGet,
    uri: `/config/${namespaceId}`
  })
}

// Updates config info for the environment
export const updateConfigNamespace = async (namespaceId, data) => {
  return await wrapCall({
    method: callPut,
    uri: `/config/${namespaceId}`,
    data
  })
}
